module.exports = __webpack_public_path__ + "img/emoji-delete-this-one-240x240.73c286a4.png";